import { gql } from '__generated__'

export const UpdateCandidateEducationMutation = gql(/* GraphQL */ `
    mutation UpdateCandidateEducation(
        $userId: ID
        $educationEntries: [EducationEntry!]
    ) {
        updateCandidateEducation(
            userId: $userId
            educationEntries: $educationEntries
        ) {
            success
            message
        }
    }
`)

export const UpdateSelfEducationExperience = gql(/* GraphQL */ `
    mutation UpdateSelfEducationExperience(
        $educationEntries: [EducationEntry!]
    ) {
        updateSelfEducationExperience(educationEntries: $educationEntries) {
            success
        }
    }
`)
